module.exports = __webpack_public_path__ + "img/global.5020645f.png";